import { UseFormReturn } from 'react-hook-form';

import { SessionPrepInfo } from 'features/sessions/config/types';
import {
  useNextSessionUpdateMutation,
  useParticipantProfileNoteUpdateMutation,
} from 'features/sessions/hooks';
import { hasDirtyFields } from 'features/sessions/utils';

export const useNextSessionUpdate = (
  formMethods: UseFormReturn<SessionPrepInfo>,
  options?: {
    coachingSessionId?: string;
    noteId?: string;
  }
) => {
  const formValues = formMethods.getValues();

  const coachingSessionId =
    options?.coachingSessionId ??
    formValues?.nextSessionAppointment?.coachingSessionId;
  const noteId = options?.noteId ?? formValues?.coachingClientNote?.noteId;

  const nextSessionMutation = useNextSessionUpdateMutation(coachingSessionId);

  const profileNoteMutation = useParticipantProfileNoteUpdateMutation({
    noteId: noteId || '',
    coachingSessionId: coachingSessionId || '',
  });

  const onMutate = async (nextSession: SessionPrepInfo) => {
    if (!coachingSessionId) {
      return;
    }

    const { dirtyFields } = formMethods.formState;
    const { coachingClientNote, ...nextSessionFields } = dirtyFields;

    const isNextSessionDirty = hasDirtyFields(nextSessionFields);
    const isClientNoteDirty = hasDirtyFields(coachingClientNote);

    const { text, dashboardLink } = nextSession.coachingClientNote;
    isClientNoteDirty &&
      noteId &&
      (await profileNoteMutation.mutateAsync({
        text,
        dashboardLink,
      }));

    isNextSessionDirty && (await nextSessionMutation.mutateAsync(nextSession));
  };

  return onMutate;
};
